import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { ConfigProvider, theme } from 'antd';

import {
    colorAccent,
    colorBgBase,
    colorBgContainer,
    colorBgElevated,
    colorPrimary,
    colorSider,
    colorText,
} from './const/colors';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <ConfigProvider
            theme={{
                algorithm: theme.darkAlgorithm,
                token: {
                    colorPrimary,
                    colorLink: colorAccent,
                    colorBgBase,
                    colorBgContainer,
                    colorBgElevated,
                    colorTextBase: colorText,
                    borderRadius: 10,
                    fontFamily:
                        "'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
                },
                components: {
                    Layout: {
                        siderBg: colorSider,
                        triggerBg: '#0f1118',
                        bodyBg: colorBgBase,
                        footerBg: colorBgBase,
                    },
                    Menu: {
                        darkItemBg: 'transparent',
                        darkSubMenuItemBg: 'transparent',
                        darkPopupBg: colorSider,
                    },
                    Card: {
                        colorBorderSecondary: 'rgba(255, 255, 255, 0.08)',
                    },
                },
            }}
        >
            <App />
        </ConfigProvider>
    </React.StrictMode>
);
